import { Badge } from '@/components/ui/badge';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { DailyExpenseTab } from '@/lib/daily-expense-tabs';

// Abas Todas / Excedidas / Sem lançamento da página de Despesas do Dia a Dia
// (chamado 3798), no mesmo visual das abas de Receitas e Despesas Mensais.

interface DailyExpenseTabsListProps {
  counts: Record<DailyExpenseTab, number | undefined>;
}

const BADGE = 'ml-1 sm:ml-2 text-[10px] sm:text-xs';

/** Lista de abas (vai dentro de `<Tabs>`); os valores são os de `DailyExpenseTab`. */
export function DailyExpenseTabsList({ counts }: Readonly<DailyExpenseTabsListProps>) {
  return (
    <div className="flex items-center justify-between overflow-x-auto">
      <TabsList className="w-full sm:w-auto">
        <TabsTrigger value="all" className="text-xs sm:text-sm">
          Todas
          {counts.all !== undefined && (
            <Badge variant="secondary" className={BADGE}>
              {counts.all}
            </Badge>
          )}
        </TabsTrigger>
        <TabsTrigger value="exceeded" className="text-xs sm:text-sm">
          Excedidas
          {!!counts.exceeded && (
            <Badge variant="destructive" className={BADGE}>
              {counts.exceeded}
            </Badge>
          )}
        </TabsTrigger>
        <TabsTrigger value="unlaunched" className="text-xs sm:text-sm">
          Sem lançamento
          {counts.unlaunched !== undefined && (
            <Badge variant="secondary" className={BADGE}>
              {counts.unlaunched}
            </Badge>
          )}
        </TabsTrigger>
      </TabsList>
    </div>
  );
}
